module.exports = "/assets/data/78978349efab668200f84b4a7a17f89f-BN44.data.json";